import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error('Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. Copy .env.example to .env.');
}

export const supabase = createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

export const mediaUrl = (path) =>
  path ? supabase.storage.from('media').getPublicUrl(path).data.publicUrl : null;

export const uploadMedia = async (userId, file, kind) => {
  // The extension comes from a user-supplied filename and ends up in a public URL,
  // so strip it to bare alphanumerics rather than trusting whatever was uploaded.
  const ext = (file.name.split('.').pop() || '').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 8) || 'png';
  const path = `${userId}/${kind}-${Date.now()}.${ext}`;
  const { error } = await supabase.storage.from('media').upload(path, file, { upsert: true });
  if (error) throw error;
  return path;
};

/** Extract X/Twitter username from OAuth session metadata */
export const getOAuthSocials = (session) => {
  if (!session?.user) return {};
  const socials = {};
  const meta = session.user.user_metadata || {};
  const provider = session.user.app_metadata?.provider;
  if (provider === 'x' || meta.user_name || meta.preferred_username) {
    const xUser = meta.user_name || meta.preferred_username || '';
    if (xUser) socials.x = `@${xUser}`;
  }
  return socials;
};
